module.exports = __webpack_public_path__ + "static/media/save@2x.7399894a.png";